import { CodetableTranslation } from "app/area/codetable/constants";
import { replaceTemplateString } from "app/infrastructure/platform";

export const getConfirmPopupDescription =
  (description: string, childrenCount: number, translation: CodetableTranslation) => !!childrenCount
    ? replaceTemplateString(
      translation.delete_with_descendants_confirm,
      description,
      String(childrenCount))
    : replaceTemplateString(translation.delete_confirm, description);
